module.exports = __webpack_public_path__ + "static/media/Skull_normal.29762b48.jpg";